import { Injectable } from '@angular/core';
import { TableColumnProvider } from '../../../interfaces/table-column-provider';
import { TableColumnService } from '../services/table-column.service';
import { TableColumn } from '../../../models/table-column';
import { EntityEnum } from 'src/app/enum/entity.enum';
import { Batch } from '../../../models/batch';
import { DateService } from '../services/date.service';
import { BatchColumnEnum } from '../../../enum/batch-column.enum';

@Injectable({
    providedIn: 'root'
})
export class BatchColumnsService implements TableColumnProvider {

    constructor(private tableColumnService: TableColumnService, private dateService: DateService) {
        this.tableColumnService.registerProvider(this);
    }

    get(id: string): TableColumn {
        switch (id) {
            case BatchColumnEnum.BATCH_NAME:
                return {
                    id: BatchColumnEnum.BATCH_NAME,
                    caption: $localize`Name`,
                    width: 150,
                    sort: 'name',
                    render: (batch: Batch) => batch.name
                };
            case BatchColumnEnum.BATCH_DATE:
                return {
                    id: BatchColumnEnum.BATCH_DATE,
                    caption: $localize`Date`,
                    width: 100,
                    sort: 'date',
                    render: (batch: Batch) => this.dateService.renderShortDate(batch.date)
                };
            case BatchColumnEnum.BATCH_COUNT:
                return {
                    id: BatchColumnEnum.BATCH_COUNT,
                    caption: $localize`# Shipments`,
                    width: 100,
                    sort: null,
                    render: (batch: Batch) => (batch.count || 0).toString(10)
                };
            case BatchColumnEnum.BATCH_PREPARING_COUNT:
                return {
                    id: BatchColumnEnum.BATCH_PREPARING_COUNT,
                    caption: $localize`# Quotes`,
                    width: 100,
                    sort: null,
                    render: (batch: Batch) => (batch.preparingCount || 0).toString(10)
                };
            case BatchColumnEnum.BATCH_MANIFESTED_COUNT:
                return {
                    id: BatchColumnEnum.BATCH_MANIFESTED_COUNT,
                    caption: $localize`# Manifested`,
                    width: 100,
                    sort: null,
                    render: (batch: Batch) => (batch.manifestedCount || 0).toString(10)
                };
            case BatchColumnEnum.BATCH_IN_TRANSIT_COUNT:
                return {
                    id: BatchColumnEnum.BATCH_IN_TRANSIT_COUNT,
                    caption: $localize`# In-Transit`,
                    width: 100,
                    sort: null,
                    render: (batch: Batch) => (batch.inTransitCount || 0).toString(10)
                };
            case BatchColumnEnum.BATCH_DELIVERED_COUNT:
                return {
                    id: BatchColumnEnum.BATCH_DELIVERED_COUNT,
                    caption: $localize`# Delivered`,
                    width: 100,
                    sort: null,
                    render: (batch: Batch) => (batch.deliveredCount || 0).toString(10)
                };
            case BatchColumnEnum.BATCH_EXCEPTION_COUNT:
                return {
                    id: BatchColumnEnum.BATCH_EXCEPTION_COUNT,
                    caption: $localize`# Exceptions`,
                    width: 100,
                    sort: null,
                    render: (batch: Batch) => (batch.exceptionCount || 0).toString(10)
                };
            case BatchColumnEnum.BATCH_VOID_COUNT:
                return {
                    id: BatchColumnEnum.BATCH_VOID_COUNT,
                    caption: $localize`# Void`,
                    width: 100,
                    sort: null,
                    render: (batch: Batch) => (batch.voidCount || 0).toString(10)
                };
        }
    }

    ids(): string[] {
        return [
            BatchColumnEnum.BATCH_NAME,
            BatchColumnEnum.BATCH_DATE,
            BatchColumnEnum.BATCH_COUNT,
            BatchColumnEnum.BATCH_DELIVERED_COUNT,
            BatchColumnEnum.BATCH_EXCEPTION_COUNT,
            BatchColumnEnum.BATCH_IN_TRANSIT_COUNT,
            BatchColumnEnum.BATCH_VOID_COUNT,
            BatchColumnEnum.BATCH_MANIFESTED_COUNT,
            BatchColumnEnum.BATCH_PREPARING_COUNT
        ];
    }

    supports(entityClass: string): boolean {
        return entityClass === EntityEnum.BATCH;
    }
}
